 
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import GridView from "../../commonComponents/gridView";

const JobAdContainer = () => {
  return (
    <>
      <Breadcrumbs title="Job Listing" url={routes.Home.JobDemo1} mainClass="job-breadcrumbs-section" />
      <GridView type="job" sectionClass="job-list-section" filterTagsClass="job-list-header" jobBoxStyle="job-ad" gridSize={1} carShow={8} />
    </>
  );
};

export default JobAdContainer;
